const Animations = ( ( window, undefined ) => {

    var wow;

    const _privateMethod = function () {
    };

    const init = function () {

        wow = new WOW({
            boxClass: 'animate',
            animateClass: 'animated',
            offset: 0,
            mobile: true,
            live: true,
            callback: function (box) {

            },
            scrollContainer: null
        });

        wow.init();

    };

    return {
        init: init
    };

})( window );